/**
 * Platform owners = Fleetwise AI (Isaac, Shane). Distinct from *company* admins
 * like Mike who only run their own shop. A platform owner can act as any user
 * **in their own company** — `platform.startImpersonation` rejects a
 * cross-company target with FORBIDDEN — so this list grants reach inside one
 * tenant, never across tenants.
 *
 * Since WP7 Phase 6 acting-as is WRITE-CAPABLE, not a read-only preview. Actions
 * are attributed to the real human via `actingAsId` in the audit log.
 *
 * Matched by email (case-insensitive).
 */
export const PLATFORM_OWNER_EMAILS: readonly string[] = [
  // Naming convention (Isaac, 2026-07-29): each owner holds TWO seats —
  // `…@airoldibrothers.com` / `…@21handshake.com` for the real shop, and
  // `…@fleetwiseai.com` for the demo tenant and platform work. Act-as is
  // company-scoped, so neither seat can reach the other's tenant; both are
  // listed here because ownership must hold on whichever one they sign in on.
  'isaac@21handshake.com',
  'srugg@airoldibrothers.com',
  'shane@fleetwiseai.com',
  // Shane's seat in the demo/training tenant. He needs act-as there to walk a
  // demo as each role without signing out, and his production address above
  // cannot reach it — act-as is company-scoped, and that account is not in the
  // sandbox. Reach is confined to the sandbox company by the same scoping rule.
  'shane.rugg@demo.fleetwiseai.com',
  // Isaac's seat in the same tenant, for the same reason.
  'isaac@fleetwiseai.com',
] as const;

export function isPlatformOwnerEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return PLATFORM_OWNER_EMAILS.includes(email.toLowerCase());
}
